import { InputEditor } from "./InputEditor";
import { DataView } from "../DataView";
import { IDataViewItem } from "../types";

export function getEditor(item: IDataViewItem, dataView: DataView) {
	return new InputEditor(item, dataView);
}
